import { render, staticRenderFns } from "./TransactionTBK.vue?vue&type=template&id=61fe7700&scoped=true&"
import script from "./TransactionTBK.vue?vue&type=script&lang=js&"
export * from "./TransactionTBK.vue?vue&type=script&lang=js&"
import style0 from "./TransactionTBK.vue?vue&type=style&index=0&id=61fe7700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fe7700",
  null
  
)

export default component.exports